module.exports = "\n<app-navbar></app-navbar>\n<app-sidemenu></app-sidemenu>\n<div class=\"wrapper\">\n  <div class=\"content\">\n  \t<router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.component.html
// module id = ./src/app/settings/settings.component.html
// module chunks = main